export const OPEN_CREATE_EVENT_DIALOG = 'CALENDAR:OPEN_CREATE_EVENT_DIALOG';
export const CLOSE_CREATE_EVENT_DIALOG = 'CALENDAR:CLOSE_CREATE_EVENT_DIALOG';
export const OPEN_SCHEDULE_SESSION_DIALOG = 'CALENDAR:OPEN_SCHEDULE_SESSION_DIALOG';
export const CLOSE_SCHEDULE_SESSION_DIALOG = 'CALENDAR:CLOSE_SCHEDULE_SESSION_DIALOG';
export const UPDATE_PREVIOUS_DIALOG = 'CALENDAR:UPDATE_PREVIOUS_DIALOG';
export const RESET = 'CALENDAR:RESET';
